import { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'

/**
 * Действия таблицы и чипы фильтров живут в разных ветках страницы, а в боковом меню
 * должны стоять в одной строке. Слот даёт таблице место в блоке фильтров, оставляя
 * состояние (разворот строк, параметры выгрузки) там же, где оно было
 */
const ActionsSlotContext = createContext<{
  element: HTMLElement | null
  setElement: (element: HTMLElement | null) => void
} | null>(null)

export const ActionsSlotProvider = ({ children }: PropsWithChildren) => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const value = useMemo(() => ({ element, setElement }), [element])

  return <ActionsSlotContext.Provider value={value}>{children}</ActionsSlotContext.Provider>
}

/** Пустое место под действия: рисуется там, где они должны появиться */
export const ActionsSlot = ({ className }: { className?: string }) => {
  const slot = useContext(ActionsSlotContext)

  if (!slot) return null

  return <div ref={slot.setElement} className={className} />
}

/** Переносит действия в слот; без слота на странице не рисует ничего */
export const ActionsPortal = ({ children }: PropsWithChildren) => {
  const slot = useContext(ActionsSlotContext)

  if (!slot?.element) return null

  return createPortal(children, slot.element)
}
